import { useFeatureGate } from '@statsig/react-bindings';

/**
 * Thin, reusable Statsig gate helper (RND-36404).
 *
 * Wraps `useFeatureGate` so components read a stable `{ value, reason }` shape
 * without reaching into `gate.details`. `reason` is the Statsig evaluation
 * reason (e.g. `Network:Recognized`, `Network:Unrecognized`, `Uninitialized`).
 *
 * Must be used inside a `StatsigProvider` (see StatsigGate).
 */
export type GateResult = {
  value: boolean;
  reason: string;
};

export const useGate = (name: string): GateResult => {
  const gate = useFeatureGate(name);
  return { value: gate.value, reason: gate.details.reason };
};
